<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';
@import '../css/admin-table.css';
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="admin-page">
    <admin-header :tit="this.title"></admin-header>
    <admin-side></admin-side>
    <section class="admin-template">
      <h2 class="sub-tit">서식 상품 관리</h2>
      <div class="contents">
        <b-container fluid>
          <!-- User Interface controls -->
            <b-row>
             <b-col class="my-1 text-left type-box">
               <!--<b-form-group
                label="매물 Type"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" id="form-select" v-model="typeSelected" :options="itemOptions"></b-form-select>
              </b-form-group>-->
            </b-col>
            <b-col class="my-1 filter-box">
              <b-form-group
                label="Filter"
                label-for="filter-input"
                label-cols-sm="1"
                label-align-sm="left"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    type="search"
                    placeholder="검색어를 입력해주세요."
                    v-model="searchText"
                  ></b-form-input>
                  <b-button size="sm" @click="itemFilter()" class="search-btn">검색</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            id="table-documnet-items"
            :items="items"
            :fields="fields"
            stacked="md"
            show-empty
            small
          >
            <template #cell(itemId)="row">
              {{ row.value }}
            </template>
            <template #cell(itemCode)="row">
              {{ row.value }}
            </template>
            <template #cell(itemName)="row">
              {{ row.value }}
            </template>
            <template #cell(itemPrice)="row">
              {{ row.value | numberToKor }}
            </template>
            <template #cell(itemRegCount)="row">
              {{ row.value }}
            </template>
            <template #cell(itemDesc)="row">
              {{ row.value }}
            </template>
            <template #cell(actions)="row">
              <!-- <input type="text" class="default-input" :value="row.index" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '')"> -->
              <b-button size="sm" @click="modifyItem(row.item, row.index)" class="save-btn mr-1">수정</b-button>
              <b-button size="sm" @click="deleteItem(row.item, row.index)" class="deleat-btn">삭제</b-button>
            </template>
            <template #row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>
           <b-row>
            <b-col lg="12" class="my-1 text-right">
              <b-button variant="primary" class="new-item-btn" @click="newModal()">신규</b-button>
            </b-col>
          </b-row>
          <b-modal
          id="doc-item-reg-modal"
          class="item-modal banner-modal"
          size="lg"
          title="서식상품 추가하기"
          >
            <b-row class="modal-top-row">
              <b-col sm="6" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                  <label>상품 ID</label>
                  <b-form-input
                    v-model="infoModal.itemId"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="6" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                <label>상품코드</label>
                <b-form-input
                  v-model="infoModal.itemCode"
                  placeholder="코드는 최대 3자리 입니다."
                ></b-form-input>
              </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="6" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>상품명</label>
                  <b-form-input
                    v-model="infoModal.itemName"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="6" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>상품가격</label>
                  <b-form-input
                    v-model="infoModal.itemPrice"
                    oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '')"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>상품상세</label>
                  <b-form-input
                    v-model="infoModal.itemDesc"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-third-area">
                <div class="my-1 text-left desc search">
                  <div class="text-right save-btn-area">
                    <b-button
                    variant="primary"
                    class="default-btn address-search btn-primary"
                    @click="modalAdd()"
                  >
                    저장
                  </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-row class="modify-footer">
              </b-row>
            </template>
          </b-modal>
          <b-modal id="doc-item-modyfiy-modal" size="lg" class="item-modal modify-modal" :title="infoModal.title" ok-only>
            <b-row class="modal-top-row">
              <b-col sm="6" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                  <label>상품 ID</label>
                  <b-form-input
                    v-model="infoModal.itemId"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="6" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                <label>상품코드</label>
                <b-form-input
                  v-model="infoModal.itemCode"
                  disabled
                ></b-form-input>
              </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="6" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>상품명</label>
                  <b-form-input
                    v-model="infoModal.itemName"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="6" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>상품가격</label>
                  <b-form-input
                    v-model="infoModal.itemPrice"
                    oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '')"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>상품상세</label>
                  <b-form-input
                    v-model="infoModal.itemDesc"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-third-area">
                <div class="my-1 text-left desc search">
                  <div class="text-right save-btn-area">
                    <b-button
                    variant="primary"
                    class="default-btn address-search btn-primary"
                    @click="modifySave()"
                  >
                    저장
                  </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-row class="modify-footer">
              </b-row>
            </template>
          </b-modal>
        </b-container>
      </div>
    </section>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminSide from '@/components/AdminSide'
// https://bootstrap-vue.org/docs/components/table
import { mapGetters } from 'vuex'

export default {
  name: 'RecommendedItems',
  components: {
    'admin-header': AdminHeader,
    'admin-side': AdminSide
  },
  data () {
    return {
      searchText: '',
      fields: [
        { key: 'itemId', label: '상품ID', class: 'text-center' },
        { key: 'itemCode', label: '상품코드', class: 'text-center', sortDirection: 'desc' },
        { key: 'itemName', label: '상품명', sortDirection: 'desc' },
        { key: 'itemPrice', label: '상품가격', class: 'text-center', sortDirection: 'desc' },
        { key: 'itemRegCount', label: '등록 수', class: 'text-center', sortDirection: 'desc' },
        { key: 'itemDesc', label: '상품상세', class: 'text-center', sortDirection: 'desc' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      infoModal: {
        title: '',
        itemId: '',
        itemType: '',
        itemCode: '',
        itemName: '',
        itemPrice: '',
        itemDesc: '',
        itemRegCount: ''
      }
    }
  },
  created () {
    this.initDocItemList()
  },
  watch: {
  },
  methods: {
    initDocItemList () {
      this.$store.dispatch('apiDocItemList', {'searchKey': this.searchText})
    },
    getParamData (obj, flag) {
      const params = {
        'flag': flag,
        'itemId': obj.itemId === '신규' ? '' : obj.itemId,
        'itemType': obj.itemType,
        'itemCode': obj.itemCode,
        'itemName': obj.itemName,
        'itemPrice': obj.itemPrice,
        'itemDesc': obj.itemDesc
      }
      return params
    },
    modifyItem (item, index) {
      this.infoModal.title = '서식상품 수정하기'
      this.infoModal.itemId = item.itemId
      this.infoModal.itemType = item.itemType
      this.infoModal.itemCode = item.itemCode
      this.infoModal.itemName = item.itemName
      this.infoModal.itemPrice = item.itemPrice
      this.infoModal.itemDesc = item.itemDesc
      this.$root.$emit('bv::show::modal', 'doc-item-modyfiy-modal')
    },
    deleteItem (item, index) {
      if (item.itemRegCount > 0) {
        alert('등록 된 데이터가 있어 삭제 할 수 없습니다.')
        return
      }
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        this.$store.dispatch('apiTranDocItem', this.getParamData(item, 'D')).then(() => {
          // console.log('this.tranRtnStr = ' + this.tranRtnStr)
          if (this.tranRtnStr.result === 'success') {
            alert('삭제 되었습니다.')
            this.initDocItemList()
          } else if (this.tranRtnStr.result === 'regCountError') {
            alert('등록 된 데이터가 있어 삭제 할 수 없습니다.')
          } else {
            alert('삭제에 실패하였습니다.')
          }
        })
        // this.items.splice(index, 1)
      } else {
        return false
      }
    },
    modalAdd () {
      this.$store.dispatch('apiTranDocItem', this.getParamData(this.infoModal, 'I')).then(() => {
        // console.log('this.tranRtnStr = ' + this.tranRtnStr)
        if (this.tranRtnStr.result === 'success') {
          this.$nextTick(() => {
            alert('등록이 완료 되었습니다.')
            this.initDocItemList()
            this.$bvModal.hide('doc-item-reg-modal')
          })
        } else if (this.tranRtnStr.result === 'duplicateError') {
          alert('중복 된 코드 입니다. 다시 입력해주세요.')
        } else {
          alert('수정 된 내용 저장에 실패하였습니다.')
        }
      })
    },
    itemFilter () {
      this.initDocItemList()
    },
    modifySave () {
      this.$store.dispatch('apiTranDocItem', this.getParamData(this.infoModal, 'U')).then(() => {
        // console.log('this.tranRtnStr = ' + this.tranRtnStr.result)
        if (this.tranRtnStr.result === 'success') {
          this.$nextTick(() => {
            alert('저장이 완료 되었습니다.')
            this.initDocItemList()
            this.$bvModal.hide('doc-item-modyfiy-modal')
          })
        } else {
          alert('수정 된 내용 저장에 실패하였습니다.')
        }
      })
    },
    newModal () {
      this.infoModal.itemId = '신규'
      this.infoModal.itemType = '002'
      this.infoModal.itemCode = ''
      this.infoModal.itemName = ''
      this.infoModal.itemPrice = ''
      this.infoModal.itemDesc = ''
      this.$root.$emit('bv::show::modal', 'doc-item-reg-modal')
      // this.$root.$emit('bv::show::modal', 'doc-item-modyfiy-modal')
    }
  },
  computed: {
    ...mapGetters({
      items: 'getDocItemList',
      tranRtnStr: 'getTranDocItem'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/AdminDocItem.vue